import { TeamSwitcher } from './TeamSwitcher';

export default TeamSwitcher;
